var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"goal-wheel page-wheels"},[(_vm.activePageCode === 'goals')?_c('div',{staticClass:"continue-button-wrapper flex-center",class:[_vm.validateSelectedGoals ? 'scale-in-center' : 'scale-out-center']}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }